import { Container, Text } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { Button, Markdown, SectionTitle, UserInfo } from '@sloyd/ui';
import { markdown } from './ContentInvitation.data';
import { Column, Wrapper } from './ContentInvitation.style';

export type ContentInvitationProps = {
  user: IUser;
  isRunning?: boolean;
  callbacks: {
    onJoin: () => void;
  };
};

export function ContentInvitation(props: ContentInvitationProps) {
  const { user, isRunning, callbacks } = props;

  return (
    <Container size='lg'>
      <SectionTitle title='Try out Sloyd V2'>🎉 You're Invited to Sloyd V2 Alpha!</SectionTitle>
      <Wrapper className='ContentInvitation-wrapper' data-testid='ContentInvitation-wrapper'>
        <Column>
          <Text>
            <Markdown mode='dark' markdown={markdown} />
          </Text>
        </Column>
        <Column>
          <UserInfo user={user} />
          <Button
            leftSection={<icons.IconMail size={18} />}
            size='lg'
            variant='gradient'
            loading={isRunning}
            onClick={callbacks.onJoin}
            gradient={{ from: 'blue', to: 'cyan' }}
          >
            Join V2 Alpha
          </Button>
        </Column>
      </Wrapper>
    </Container>
  );
}

export default ContentInvitation;
